export const setResources = 'ui/setResources';
export const setUiStatus = 'ui/setUiStatus';
export const setConfig = 'ui/setConfig';
export const setFormStep = 'ui/setFormStep';
export const setUpdatingCoverage = 'ui/setUpdatingCoverage';
export const setDataPolicyContentBlock = 'ui/setDataPolicyContentBlock';
export const setTerminationFeeContentBlock = 'ui/setTerminationFeeContentBlock';
export const setHasContentInsurance = 'ui/setHasContentInsurance';
export const setModel = 'form/setModel';
export const updateModel = 'form/updateModel';
export const setInsuranceShouldTerminate = 'form/setInsuranceShouldTerminate';
export const setInsuranceTerminateDate = 'form/setInsuranceTerminateDate';
export const setShowNewInsuranceStartDateInputType = 'form/setShowNewInsuranceStartDateInputType';
export const setInsuranceCompany = 'form/setInsuranceCompany';
export const setInsuranceNumber = 'form/setInsuranceNumber';
export const setNewInsuranceStartDate = 'form/setNewInsuranceStartDate';
export const setCustomerName = 'form/setCustomerName';
export const setCustomerCpr = 'form/setCustomerCpr';
export const setCustomerAddress = 'form/setCustomerAddress';
export const setCustomerMobile = 'form/setCustomerMobile';
export const setCustomerEmail = 'form/setCustomerEmail';
export const checkSkybrud = 'form/checkSkybrud';
export const checkSkader = 'form/checkSkader';
export const checkGaeld = 'form/checkGaeld';
export const setRegNum = 'form/setRegNum';
export const setAccountNum = 'form/setAccountNum';
export const setIsSomeoneElseAccount = 'form/setIsSomeoneElseAccount';
export const setAccountHolderCprNumber = 'form/setAccountHolderCprNumber';
export const setAgreeTermsOfPurchase = 'form/setAgreeTermsOfPurchase';
export const setAgreeObtainInfo = 'form/setAgreeObtainInfo';
export const setIsPaymentValid = 'form/setIsPaymentValid';
